/**
 * some approaches to check constructability:
 * - just try construction and catch - invokes ctor
 * - use try-catch with Reflect.construct - invokes ctor?
 * - use ES6-proxy with try-catch and intercept invoking the actual ctor (but ensuring it exists)
 * https://stackoverflow.com/questions/40922531/how-to-check-if-a-function-is-a-constructor
 * https://github.com/zloirock/core-js/blob/master/packages/core-js/internals/is-constructor.js#L15
 *
 */
/**
 * based on core-js isConstructor polyfill
 * https://github.com/zloirock/core-js/blob/master/packages/core-js/internals/is-constructor.js
 */
const isCallable = argument => {
  return typeof argument === 'function';
};
const classof = it => {
  return ''.slice.call(Object.toString.call(it), 8, -1);
};
const inspectSource = it => {
  return Function.toString.call(it);
};
const fails = exec => {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
}; // returns true if inner fn throws or returns truthy result
const noop = function () {};
const constructorRegExp = /^\s*(?:class|function)\b/;
const INCORRECT_TO_STRING = !constructorRegExp.test(noop.toString());
let supportsModern = true;
function isCtorModern(argument) {
  if (!isCallable(argument)) return false;
  try {
    Reflect.construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
}
;
function isCtorFallback(argument) {
  if (!isCallable(argument)) return false;
  if (['AsyncFunction', 'GeneratorFunction', 'AsyncGeneratorFunction'].includes(classof(argument))) return false;
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    return INCORRECT_TO_STRING || !!constructorRegExp.exec(inspectSource(argument));
  } catch (error) {
    return true;
  }
}
;
if (fails(() => {
  var called;
  return isCtorModern(isCtorModern.call) || !isCtorModern(Object) || !isCtorModern(function () {
    called = true;
  }) || called;
})) {
  supportsModern = false;
}
export function isConstructor(x) {
  return supportsModern ? isCtorModern(x) : isCtorFallback(x);
}